function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56 8.333H21c-1.375 0-2.5 1.072-2.5 2.381v28.572c0 1.31 1.125 2.38 2.5 2.38h35c1.375 0 2.5-1.07 2.5-2.38V10.714c0-1.31-1.125-2.38-2.5-2.38z",
  fill: "#F7F8FA"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ACB5C2",
  d: "M18.5 13h40v1.333h-40z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20.833,
  cy: 10.667,
  r: 1,
  fill: "#ACB5C2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.167 9.667c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zM27.5 11.667c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1zM45.167 18.333v13.334H54.5V18.333h-9.333z",
  fill: "#ACB5C2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.5 18.333v20h20v-20h-20z",
  fill: "#D4DAE1"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M124.75 0h-52.5c-2.063 0-3.75 1.607-3.75 3.571V46.43c0 1.964 1.688 3.571 3.75 3.571h52.5c2.062 0 3.75-1.607 3.75-3.571V3.57c0-1.964-1.688-3.571-3.75-3.571z",
  fill: "#E4E7EC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ACB5C2",
  d: "M68.5 7h60v2h-60z"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 72,
  cy: 3.5,
  r: 1.5,
  fill: "#ACB5C2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M77 2c-.9 0-1.5.6-1.5 1.5S76.1 5 77 5s1.5-.6 1.5-1.5S77.9 2 77 2zM82 5c.9 0 1.5-.6 1.5-1.5S82.9 2 82 2s-1.5.6-1.5 1.5S81.1 5 82 5z",
  fill: "#ACB5C2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M108.5 15v20h14V15h-14z",
  fill: "#748499"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M73 15v30h30V15H73z",
  fill: "#ACB5C2"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M166.625 12.5h-26.25c-1.031 0-1.875.804-1.875 1.786v21.428c0 .982.844 1.786 1.875 1.786h26.25c1.031 0 1.875-.804 1.875-1.786V14.286c0-.982-.844-1.786-1.875-1.786z",
  fill: "#F7F8FA"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ACB5C2",
  d: "M138.5 16h30v1h-30z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140.25,
  cy: 14.25,
  r: 0.75,
  fill: "#ACB5C2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M142.75 13.5c-.45 0-.75.3-.75.75s.3.75.75.75.75-.3.75-.75-.3-.75-.75-.75zM145.25 15c.45 0 .75-.3.75-.75s-.3-.75-.75-.75-.75.3-.75.75.3.75.75.75zM158.5 20v10h7V20h-7z",
  fill: "#ACB5C2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M140.75 20v15h15V20h-15z",
  fill: "#D4DAE1"
}));

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 52.5,
  cy: 52,
  r: 2,
  fill: "#E4E7EC"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 41.5,
  r: 1.5,
  fill: "#E4E7EC"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 41.5,
  r: 1.5,
  fill: "#E4E7EC"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 41.5,
  cy: 46,
  r: 1,
  fill: "#ACB5C2"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 45,
  r: 1,
  fill: "#D4DAE1"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 31.5,
  cy: 50,
  r: 1,
  fill: "#748499"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 47,
  r: 1,
  fill: "#ACB5C2"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 145.5,
  cy: 40,
  r: 2,
  transform: "rotate(180 145.5 40)",
  fill: "#E4E7EC"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 50.5,
  r: 1.5,
  transform: "rotate(180 136 50.5)",
  fill: "#E4E7EC"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 186,
  cy: 50.5,
  r: 1.5,
  transform: "rotate(180 186 50.5)",
  fill: "#E4E7EC"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 156.5,
  cy: 46,
  r: 1,
  transform: "rotate(180 156.5 46)",
  fill: "#ACB5C2"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 179.5,
  cy: 47,
  r: 1,
  transform: "rotate(180 179.5 47)",
  fill: "#D4DAE1"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 166.5,
  cy: 42,
  r: 1,
  transform: "rotate(180 166.5 42)",
  fill: "#748499"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 196.5,
  cy: 45,
  r: 1,
  transform: "rotate(180 196.5 45)",
  fill: "#ACB5C2"
});

function SvgEmptyJourney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 198 54",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

export default __webpack_public_path__ + "empty-journey-48d3e93707652dd86725305b7372c915.svg";
export { SvgEmptyJourney as ReactComponent };